import { createContext } from 'react';
import type { EventStats } from '@/lib/ditto';

export interface EventStatsBatchContextType {
  /**
   * Request Ditto's precomputed engagement stats (NIP-85 kind 30383) for an
   * event id. Calls within a short window are coalesced into a single batched
   * relay query against the Ditto relay. Resolves `null` when Ditto has no
   * assertion for the event (so callers can fall back to client-side counting).
   */
  load: (eventId: string) => Promise<EventStats | null>;
}

export const EventStatsBatchContext = createContext<EventStatsBatchContextType | undefined>(undefined);
